var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 1.33325C7.59368 1.33325 7.26041 1.66669 7.26041 2.07422V8.00194C7.26041 8.40947 7.59368 8.74291 8.001 8.74291C8.40833 8.74291 8.7416 8.40947 8.7416 8.00194V2.07422C8.7416 1.66669 8.40833 1.33325 8.001 1.33325ZM11.8077 3.45241C11.5188 3.74139 11.5262 4.19338 11.8002 4.48236C12.6371 5.37151 13.1555 6.55706 13.1852 7.86857C13.2518 10.7065 10.9041 13.1517 8.06766 13.1813C5.17194 13.2257 2.81685 10.8917 2.81685 8.00194C2.81685 6.63856 3.34268 5.40115 4.20176 4.47495C4.47578 4.18597 4.47578 3.73398 4.19436 3.45241C3.89812 3.15603 3.41673 3.16344 3.13531 3.46723C2.06145 4.60832 1.38751 6.1273 1.33567 7.80929C1.23199 11.4252 4.17214 14.5521 7.78623 14.6632C11.5633 14.7818 14.6663 11.7512 14.6663 7.99453C14.6663 6.23844 13.985 4.65278 12.8741 3.46723C12.5927 3.16344 12.1039 3.15603 11.8077 3.45241Z",
    fill: "#FFF7EB",
    stroke: "#FFF7EB",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettings);
export default __webpack_public_path__ + "static/media/power-settings.b1ade3ac4a979a8a5378862139e7c1dd.svg";
export { ForwardRef as ReactComponent };